export enum RecaptchaAction {
  LOGIN = 'login',
  VERIFY_LOGIN = 'verify_login',
  FORM_SUBMISSION = 'form_submission',
}
